import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Link } from 'react-router';
import QueryDialog from '../components/QueryBuilder/QueryDialog';

import { BigBreadcrumbs } from '../../../components';
import {
  requestQueryBuilderData,
  performSearch,
  requestTypeahead,
  requestQueries,
  addQuery,
  updateQuery,
  deleteQuery,
} from '../../../store/query-builder/QueryBuilderActions';
import Moment from '../../../components/utils/Moment';

function QueryBuilderContainer(props) {
  const [pageSize, setPageSize] = useState(25);
  const [editValues, seteEitValues] = useState({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!props.queryBuilder.queries && !props.queryBuilder.isQueriesLoading) {
      props.getQueries(props.currentUser.data.id);
    }
  });

  const editQuery = vals => {
    seteEitValues({
      id: vals.id,
      title: vals.title,
      description: vals.description,
      query: vals.query,
    });
    setShowModal(true);
  };

  const deleteQuery = id => {
    if (window.confirm(`Are you sure you want to delete query?`)) {
      props.deleteQuery(props.currentUser.data.id, id).then(res => {
        props.getQueries(props.currentUser.data.id);
      });
    }
  };

  const updateQueryValues = e => {
    props.updateQuery(props.currentUser.data.id, e).then(() => {
      setShowModal(false);
      props.getQueries(props.currentUser.data.id);
    });
  };

  return (
    <div id="content">
      <BigBreadcrumbs
        items={['Practice Management', 'Query Manager']}
        icon="fa fa-fw fa-hospital-o"
        className=""
      />
      <div className="btn-group" style={{ marginBottom: '10px' }}>
        <Link to="/builder" className="btn btn-default">
          Query Builder
        </Link>
      </div>
      <QueryDialog
        show={showModal}
        initialValues={editValues}
        onSubmit={updateQueryValues}
        onClose={() => {
          setShowModal(false);
        }}
      />
      <ReactTable
        loading={
          props.queryBuilder.isQueriesLoading ||
          props.queryBuilder.isQueryDeleting
        }
        data={props.queryBuilder.queries ? props.queryBuilder.queries : []}
        columns={[
          {
            Header: '',
            id: 'actions',
            width: 80,
            sortable: false,
            Cell: row => (
              <span>
                <button
                  className="btn btn-default btn-xs"
                  onClick={() => editQuery(row.original)}
                >
                  <i className="fa fa-pencil" />
                </button>
                {` `}
                <button
                  className="btn btn-danger btn-xs"
                  onClick={() => deleteQuery(row.original.id)}
                >
                  <i className="fa fa-trash" />
                </button>
              </span>
            ),
          },
          // {
          //   Header: 'ID',
          //   id: 'id',
          //   accessor: 'id',
          // },
          {
            Header: 'Title',
            id: 'title',
            accessor: 'title',
          },
          {
            Header: 'Description',
            id: 'description',
            accessor: 'description',
          },
          {
            Header: 'Created At',
            id: 'createdAt',
            accessor: 'createdAt',
            Cell: row => (
              <Moment date={row.original.createdAt} format="MM/DD/YYYY HH:mm" />
            ),
          },
        ]}
        defaultPageSize={pageSize}
        className="-striped -highlight"
      />
    </div>
  );
}

export default connect(
  state => ({
    queryBuilder: state.queryBuilder,
    currentUser: state.currentUser,
  }),
  dispatch => ({
    getQueryBuilderData: params => dispatch(requestQueryBuilderData(params)),
    performSearch: (data, params) => dispatch(performSearch(data, params)),
    typeahead: (url, params) => dispatch(requestTypeahead(url, params)),
    getQueries: (userID, params) => dispatch(requestQueries(userID, params)),
    addQuery: (userID, body) => dispatch(addQuery(userID, body)),
    updateQuery: (userID, body) => dispatch(updateQuery(userID, body)),
    deleteQuery: (userID, queryID) => dispatch(deleteQuery(userID, queryID)),
  }),
)(QueryBuilderContainer);



// WEBPACK FOOTER //
// ./src/routes/management/containers/QueryManager.js